import React, {
  useEffect, useState,
} from 'react';

import * as Styles from './Rebuild.styles';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'gatorcomponents';

import useLocale from '@/hooks/useLocale';
import { useResize } from '@/hooks/useResize';

import ContentSection from '@/pages/Products/VpsOciDetailPage/components/ContentSection';
import ModalRebuild from '@/pages/Products/VpsOciDetailPage/ProductTemplatesPage/components/Rebuild/components/ModalRebuild';

import { vpsOciActions } from '@/redux/modules/productDetail/vpsOci';

const Rebuild = () => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const vpsOci = useSelector(state => state.vpsOci);
  const { vps } = (vpsOci && vpsOci.data) || {};

  const { productDetails: productDetailsLocale } = useLocale();
  const { vpsOci: localeVpsOci } = productDetailsLocale;
  const { rebuild: localeRebuild } = localeVpsOci && localeVpsOci.store;

  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 600;

  useEffect(() => {
    dispatch(vpsOciActions.rebuild.reset());
  }, [dispatch]);

  const handleStartRebuild = () => {
    setShowModal(true);
  };

  if (!vps || Object.keys(vps).length === 0) return null;

  return (
    <ContentSection
      testId="vpsoci-templates-rebuild-container"
      title={localeRebuild.title}
    >
      <Styles.Wrapper>
        <Styles.Description data-testid="vpsoci-templates-rebuild-description">{localeRebuild.description}</Styles.Description>

        <Styles.ButtonWrapper>
          <Button
            label={localeRebuild.button}
            variant="primary"
            size="large"
            width={isMobile ? 'full' : 'fit-content'}
            onClick={handleStartRebuild}
            testId="vpsoci-templates-rebuild-button"
          />
        </Styles.ButtonWrapper>

        {showModal && (
          <ModalRebuild
            onClose={() => setShowModal(false)}
          />
        )}
      </Styles.Wrapper>
    </ContentSection>
  );
};

export default Rebuild;
